import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TreeviewSystemsComponent } from '../treeview-systems/treeview-systems.component'
// @ts-ignore
import { folder_manager, user_access, system_manager } from '../assets/conf_urls.json';
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from '../app/services/auth.service';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-folder-manager',
  templateUrl: './folder-manager.component.html',
  styleUrls: ['./folder-manager.component.css']
})
export class FolderManagerComponent implements OnInit {
  isLinear = false;
  parent_folder_id = '';
  selected_folder: any;
  selected_parent_folder_name = '';
  selected_parent_folder_id = '';
  message: any;
  // #create
  CreateFolder_FormGroup: FormGroup;
  updateFolderForm: FormGroup;
  moveFolderFormGroup: FormGroup;
  deleteFolderFormGroup: FormGroup;
  create_response_message = '';
  update_response_message = '';
  move_response_message = '';
  move_source_folder: any;
  move_dest_folder: any;
  delete_response_message = '';
  show_progressbar = false;
  parsed_data = []
  disable_upload_button = true
  msg_upload = ''
  //for user access
  user_permission;
  user_email = localStorage.getItem('useremail');
  sort_tree_by = "folder"
  updateBtnErrorMsg: string;
  //old version
  // for user access
  get_user_access_service(useremail: any) {
    useremail = useremail.trim();

    localStorage.setItem('useremail', useremail);
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.url, json_object).subscribe(data => {

      if (data.toString().length > 0) {
        //if user active
        if (data[0]['is_active'] == 'y') {
          var useraccess = data[0]['user_permission'];
          localStorage.setItem('ua', useraccess);
          //create a session
          //end
          // window.location.href = '/home';
        }
        //if user not active
        if (data[0]['is_active'] == 'n') {
          window.location.href = '/newaccess';
        }
      }

    }
    );
    //  end
  }

  //old version
  check_auth() {
    // for user access
    this.user_permission = localStorage.getItem('ua');
    if (this.user_permission && this.user_email) {

      this.get_user_access_service(this.user_email);

    } else {
      //  user has to login
      window.location.href = '/login';
    }
    //end
  }

  //end
  constructor(private _formBuilder: FormBuilder,
    private http: HttpClient,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private loggerService: LoggerService,
    @Inject(DOCUMENT) document,
    private route: Router) {
  }


  reload_treeView() {
    // let element: HTMLElement = document.getElementById('refreshID') as HTMLElement;
    // element.click();
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate(["/foldermanager"])
  }

  ngOnInit(): void {

    this.authService.check_auth(localStorage.getItem('accessToken'))

    this.CreateFolder_FormGroup = this._formBuilder.group({
      item_name: ['', Validators.required],
      item_parent_id: ['0', Validators.required],
      event: ['create']
    });
    this.updateFolderForm = this._formBuilder.group({
      item_name: ['', Validators.required],
      id: ['', Validators.required],
      event: ['update']
    });
    this.moveFolderFormGroup = this._formBuilder.group({
      id: ['', Validators.required],
      item_parent_id: ['', Validators.required],
      item_src_name: ['', Validators.required],
      item_dest_name: ['', Validators.required],
      event: ['move']
    });
    this.deleteFolderFormGroup = this._formBuilder.group({
      id: ['', Validators.required],
      item_name: ['',],
      event: ['delete']
    });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  //old version
  receiveMessage($event) {
    this.message = $event;
    this.parent_folder_id = $event;
  }


  receiveMessage2($event) {

    this.selected_folder = $event;
    this.selected_parent_folder_name = $event.text;
    this.selected_parent_folder_id = $event.value.id;
    this.updateFolderForm.get('item_name').setValue(this.selected_parent_folder_name);
    this.updateFolderForm.get('id').setValue(this.selected_parent_folder_id);
    this.deleteFolderFormGroup.get('item_name').setValue(this.selected_parent_folder_name);
    this.deleteFolderFormGroup.get('id').setValue(this.selected_parent_folder_id);
  }

  onSubmit_create_folder() {
    this.show_progressbar = true;
    this.CreateFolder_FormGroup.value['event'] = 'create'
    //return
    this.http.post(folder_manager.add_folder, this.CreateFolder_FormGroup.value).subscribe(dataresponse => {
      this.show_progressbar = false;
      this.create_response_message = dataresponse['message'];
      this.reload_treeView()
      this.CreateFolder_FormGroup.reset();
    }, err => {
      this.loggerService.log("FolderManagerComponent", err.message, Levels.error)
    });
    this.show_progressbar = false;

  }

  assign_move_src_folder(item) {
    this.selectedFolderToMove = item;
    this.moveFolderFormGroup.patchValue({ "item_src_name": item['text'], "id": item["value"]['id'] })
    this.parent_folder_id = "";
  }

  assign_move_dest_folder(item) {
    this.disableMoveButton()
    this.destinationFolder = item;
    this.moveFolderFormGroup.patchValue({ "item_dest_name": item['text'], "item_parent_id": item["value"]['id'] })
    this.parent_folder_id = "";
  }

  onSubmit_update_folder() {
    if (confirm("Are you sure to update '" + this.selected_folder.text + "'?")) {
      this.show_progressbar = true;
      this.updateFolderForm.value['event'] = 'update'
      this.http.post(folder_manager.add_folder, this.updateFolderForm.value).subscribe(dataresponse => {
        this.show_progressbar = false;
        this.update_response_message = dataresponse['message'];
        this.reload_treeView()

        this.show_progressbar = false;
        this.updateFolderForm.reset();
      }, err => {
        this.loggerService.log("FolderManagerComponent", err.message, Levels.error)
      });
    }
    else {
      this.update_response_message = "Cancelled";
      this.updateFolderForm.reset();
    }
  }

  onSubmit_delete_folder() {
    if (confirm("Are you sure to delete '" + this.deleteFolderFormGroup.get("item_name").value + "'?")) {
      this.show_progressbar = true;
      this.deleteFolderFormGroup.value['event'] = 'delete'
      this.http.post(folder_manager.add_folder, this.deleteFolderFormGroup.value).subscribe(dataresponse => {
        this.show_progressbar = false;
        this.delete_response_message = dataresponse['message'];
        this.openSnackBar(dataresponse['message'], "Success");
        this.show_progressbar = false;
        this.reload_treeView()
        this.deleteFolderFormGroup.reset();
      }, err => {
        this.loggerService.log("FolderManagerComponent", err.message, Levels.error)
        this.delete_response_message = err['message'];
        this.openSnackBar(err['message'], "Error");
      });

    }
    else {
      this.delete_response_message = "Cancelled";
    }
  }



  submit_move_folder(is_root: any) {
    if (!this.checkFoldersState() && is_root != 'root') {
      return;
    }
    if (confirm("Are you sure to move '" + this.moveFolderFormGroup.get('item_src_name').value + "' to be under '" + this.moveFolderFormGroup.get('item_dest_name').value + "'?")) {
      this.move_response_message = ""
      if (is_root == 'root') {
        this.show_progressbar = true;
        this.moveFolderFormGroup.value['event'] = "move"
        this.moveFolderFormGroup.value['item_parent_id'] = 0
        this.http.post(folder_manager.add_folder, this.moveFolderFormGroup.value).subscribe(dataresponse => {
          this.show_progressbar = false;
          this.move_response_message = dataresponse['message'];
          this.show_progressbar = false;
          this.reload_treeView()
          this.moveFolderFormGroup.reset();
        }, err => {
          this.loggerService.log("FolderManagerComponent", err.message, Levels.error)
        });
      }

      else if (this.moveFolderFormGroup.valid) {


        this.show_progressbar = true;
        this.moveFolderFormGroup.value['event'] = "move"
        this.http.post(folder_manager.add_folder, this.moveFolderFormGroup.value).subscribe(dataresponse => {
          this.show_progressbar = false;
          this.move_response_message = dataresponse['message'];
          this.show_progressbar = false;
          this.reload_treeView()
          this.moveFolderFormGroup.reset();
        }, err => {
          this.loggerService.log("FolderManagerComponent", err.message, Levels.error)
        });



      }
    }
    else {
      this.move_response_message = "Cancelled";
    }
  }

  disableMoveButton(): boolean {
    let disableBtn = false;
    if (this.selected_folder && disableBtn == false) {
      if (this.selected_folder.value.id == this.selectedFolderToMove.value.id) {
        this.updateBtnErrorMsg = "* You chose the same parent folder."
        disableBtn = true;
        return disableBtn;
      } else if (this.selected_folder.children && this.selected_folder.children.length > 0
        && this.selected_folder.children[0].value.type == 'endpoint') {
        this.updateBtnErrorMsg = "* Cannot move folder to another folder that contains endpoint(s)."
        disableBtn = true;
        return disableBtn;
      }
    }
    return disableBtn;
  }

  disableCreateButton(): boolean {
    let disableBtn = false;
    if (this.selected_folder && disableBtn == false) {
      if (this.selected_folder.children && this.selected_folder.children.length > 0
        && this.selected_folder.children[0].value.type == 'endpoint' && this.CreateFolder_FormGroup.value['item_parent_id'] != 0) {
        this.updateBtnErrorMsg = "* Cannot create folder under another folder that contains endpoint(s)."
        disableBtn = true;
        return disableBtn;
      }
    }
    return disableBtn;
  }

  parse_bulk_data() {
    let switcher = true;
    this.parsed_data = []
    this.msg_upload = ''
    this.disable_upload_button = true


    const csv_data = (<HTMLInputElement>document.getElementById('csv_data')).value.trim();
    this.parsed_data = csv_data.split('\n')

    this.parsed_data.forEach(item => {


      if (!item.includes(',') || item.length == 0) {
        this.msg_upload = 'please make sure that you entered the correct data format, error in: ' + item + ' '
        this.disable_upload_button = true
        switcher = false
      } else {

        this.disable_upload_button = false
      }
    })
    if (switcher !== true) {

      this.disable_upload_button = true
    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for (j = 0; j < 32; j++) {
      if (j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

  upload_systems_to_folder() {

    this.parsed_data.forEach(item => {
      var id = this.generateGuid().split('-')[0]
      var system_ip = item.split(',')[0].trim()
      var system_password = item.split(',')[1].trim()
      var system_name = "new_system_" + id
      var system_mac_address = "temp_" + id
      if (item.includes(',') || item.length > 0) {
        let json_obj = {
          "event": "create",
          "system_name": system_name,
          "system_ip": system_ip,
          "system_mac_address": system_mac_address,
          "system_password": system_password,
          "phonebook_fk_id": "GeneralPhonebook",
          "product_id": "not synced",
          "software_version": "not synced",
          "software_name": "not synced",
          "folder_id_id": this.selected_parent_folder_id
        }
        this.http.post(system_manager.services, json_obj).subscribe(data => {
          if (data['message'] == 'Success') {
            this.openSnackBar("Data was uploaded to " + this.selected_parent_folder_name + " ", "")
          }
          else {
            this.openSnackBar(data['message'], "")

          }
          document.getElementById('refreshID').click();
        }, err => {
          this.loggerService.log("FolderManagerComponent", err.message, Levels.error)

        })
      }

    })
  }


  //starting from here this code is for the iogic of allowing or disallowing the moving of a folder under another folder
  selectedFolderToMove: any = null;
  destinationFolder: any = null;
  //function this.submit_move_folder is used to confirm the folders movement but with the below additional logic confirmed.

  // to check if the folder is eligible to be under the destination folder or not based on:
  //1-the destination folder id is not a child of the selected folder.
  //2-the destination folder must be of type folder.
  moveFolderErrorMessage: string = null;

  //function to check if the id of a certain folder or endpoint lies under a child of a tree and return this element if found or null.
  searchTree(tree: any, searchedId: number) {
    if (tree) {
      if (tree.value.id == searchedId) {
        return tree;
      } else if (tree.children != null) {
        let result = null;
        for (let i = 0; result == null && i < tree.children.length; i++) {
          result = this.searchTree(tree.children[i], searchedId);
        }
        return result;
      }
      return null;
    } else {
      return null;
    }

  }

  checkFoldersState(): boolean {
    this.moveFolderErrorMessage = null;

    if (!this.selectedFolderToMove || !this.destinationFolder) {
      this.moveFolderErrorMessage = "* Check selected and destination folder"
      return false;
    } else if (this.selectedFolderToMove.value.type != 'folder') {
      this.moveFolderErrorMessage = "* The selected element must be a folder."
      return false;
    } else if (this.destinationFolder.value.type != 'folder') {
      this.moveFolderErrorMessage = "* The destination element must be a folder."
      return false;
    } else if (this.searchTree(this.selectedFolderToMove, this.destinationFolder.value.id)) {
      this.moveFolderErrorMessage = "* The selected folder cannot move under one of its child folders."
      return false;
    }
    return true;
  }

}
